import React from "react";
import PropTypes from "prop-types";
import { FooterWrapper, Copyright } from "./partial";
import Logo from "../logo";

const PageFooter = ({ url, children, logoUrl, logoAlt }) => (
  <FooterWrapper>
    <Logo url={url} logoUrl={logoUrl} logoAlt={logoAlt} />
    <Copyright />
  </FooterWrapper>
);

PageFooter.propTypes = {
  /**
   * Url del enlace
   */
  url: PropTypes.string,
  /**
   ** Url del logo
   **/
  logoUrl: PropTypes.string,
  /**
   ** Texto alternativo del logo
   **/
  logoAlt: PropTypes.string,
};

export default PageFooter;
